<div class="flex-container gap-6" style="height: 100%">
  <div class="flex-col" style="gap: 1px">
    <vl-widget-title
      [text]="'stats.evolution_prix_vente' | trans"
      [widget]="widget()"
      [draggable]="!!widget()"
      [editable]="false"
    >
      <ng-content class="drag-handler" select=".drag-handler"></ng-content>
    </vl-widget-title>
    @if (summaryLabel()) {
      <span class="caption on-disabled" style="padding-left: 40px">{{ summaryLabel() }}</span>
    }
  </div>

  @if (metadata()?.loading) {
    <div class="h100 flex-row gap-16 widget-content">
      <div class="h100 w100 overflow-hidden">
        <ngx-skeleton-loader
          [count]="1"
          [theme]="{
                height: '260px',
                'background-color': 'var(--color-on-disabled)',
              }"
        ></ngx-skeleton-loader>
      </div>
    </div>
  } @else {
    @if (articlesOptions().length) {
      <div class="flex-row align-center gap-8">
        <div class="grow" style="min-width: 0">
          <vl-select-autocomplete
            [options]="articlesOptions()"
            [value]="selectedArticleId()"
            (valueChange)="selectedArticleId.set($event)"
          ></vl-select-autocomplete>
        </div>
        <vl-chips-toggle [elements]="chartModeElements" [(value)]="chartMode" size="small"/>
        @if (pointsTop().length) {
          <vl-chips state="active" size="small" iconRight="open_in_new" (action)="openFullList()">
            {{ 'button.see_all' | trans }}
          </vl-chips>
        }
      </div>
    }

    @if (pointsTop().length) {
      <div class="canvas-wrap w100 widget-content fade-in">
        <canvas #articleVente style="width:100%; display:block;"></canvas>
      </div>
    } @else {
      <div class="widget-content empty">
        <div class="caption on-disabled">
          {{ "filters.no_data" | trans }}
        </div>
      </div>
    }
  }
</div>
